/* The Horse Show Husband — theme interactions */
(function(){
  'use strict';
  var $=function(s,c){return (c||document).querySelector(s);};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
  var money=function(cents){
    try{return (window.Shopify&&Shopify.currency)?'$'+(cents/100).toFixed(2):'$'+(cents/100).toFixed(2);}catch(e){return '$'+(cents/100).toFixed(2);}
  };

  /* ---------- mobile menu ---------- */
  function bindMobileMenu(){
    var ov=$('#mnavOverlay'),mn=$('#mnav');
    if(!mn)return;
    function open(){ov.classList.add('open');mn.classList.add('open');document.body.style.overflow='hidden';}
    function close(){ov.classList.remove('open');mn.classList.remove('open');document.body.style.overflow='';}
    $$('[data-mnav-open]').forEach(function(b){b.addEventListener('click',open);});
    $$('[data-mnav-close]').forEach(function(b){b.addEventListener('click',close);});
    if(ov)ov.addEventListener('click',close);
  }

  /* ---------- header search ---------- */
  function bindSearch(){
    var bar=$('#searchbar');
    if(!bar)return;
    $$('[data-search-toggle]').forEach(function(b){
      b.addEventListener('click',function(){
        bar.classList.toggle('open');
        if(bar.classList.contains('open')){var i=$('input',bar);if(i)setTimeout(function(){i.focus();},120);}
      });
    });
  }

  /* ---------- cart drawer ---------- */
  function openDrawer(){var o=$('#drawerOverlay'),d=$('#cartDrawer');if(d){o.classList.add('open');d.classList.add('open');document.body.style.overflow='hidden';}}
  function closeDrawer(){var o=$('#drawerOverlay'),d=$('#cartDrawer');if(d){o.classList.remove('open');d.classList.remove('open');document.body.style.overflow='';}}
  window.thshOpenCart=openDrawer;

  function renderDrawer(cart){
    var body=$('#drawerBody'),foot=$('#drawerFoot'),sub=$('#drawerSubtotal'),cnt=$$('[data-cart-count]');
    cnt.forEach(function(el){el.textContent=cart.item_count;el.style.display=cart.item_count>0?'':'none';});
    if(!body)return;
    if(cart.item_count===0){
      body.innerHTML='<div class="dempty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" width="46" height="46"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.6 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg><p>Your cart is empty.</p><button class="btn btn-primary" data-drawer-close>Start shopping</button></div>';
      if(foot)foot.style.display='none';
      bindDrawerControls();
      return;
    }
    if(foot)foot.style.display='';
    var html='';
    cart.items.forEach(function(it){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_160x$1$2'):'';
      html+='<div class="litem" data-key="'+it.key+'">'+
        '<div class="lthumb">'+(img?'<img src="'+img+'" alt="">':'')+'</div>'+
        '<div><div class="ltitle">'+it.product_title+'</div>'+
        '<div class="lvar">'+(it.variant_title?it.variant_title:'')+'</div>'+
        '<div class="lqty"><button data-dec aria-label="Decrease">&minus;</button><span class="qv">'+it.quantity+'</span><button data-inc aria-label="Increase">+</button></div></div>'+
        '<div class="lright"><div class="lprice">'+money(it.final_line_price)+'</div>'+
        '<button class="lremove" data-remove>Remove</button></div></div>';
    });
    body.innerHTML=html;
    if(sub)sub.textContent=money(cart.total_price);
    bindDrawerControls();
  }

  function bindDrawerControls(){
    $$('[data-drawer-close]').forEach(function(b){b.addEventListener('click',closeDrawer);});
    $$('#cartDrawer .litem').forEach(function(row){
      var key=row.getAttribute('data-key');
      var qv=$('.qv',row);var q=qv?parseInt(qv.textContent,10):1;
      var inc=$('[data-inc]',row),dec=$('[data-dec]',row),rm=$('[data-remove]',row);
      if(inc)inc.addEventListener('click',function(){changeItem(key,q+1);});
      if(dec)dec.addEventListener('click',function(){changeItem(key,Math.max(0,q-1));});
      if(rm)rm.addEventListener('click',function(){changeItem(key,0);});
    });
  }

  function fetchCart(cb){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(cb);}
  function changeItem(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(function(cart){renderDrawer(cart);syncCartPage();});
  }

  function bindAddToCart(){
    $$('form[action^="/cart/add"]').forEach(function(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var btn=$('[type="submit"]',form);var txt=btn?btn.textContent:'';
        if(btn){btn.disabled=true;btn.textContent='Adding…';}
        fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
          .then(function(r){return r.json();})
          .then(function(){return fetch('/cart.js',{headers:{'Accept':'application/json'}});})
          .then(function(r){return r.json();})
          .then(function(cart){renderDrawer(cart);openDrawer();if(btn){btn.disabled=false;btn.textContent=txt;}})
          .catch(function(){if(btn){btn.disabled=false;btn.textContent=txt;}});
      });
    });
  }

  /* keep /cart page in sync if present */
  function syncCartPage(){if($('#cartPage'))fetchCart(function(c){if(c.item_count===0)location.reload();});}

  function bindCartTriggers(){$$('[data-cart-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();openDrawer();});});var o=$('#drawerOverlay');if(o)o.addEventListener('click',closeDrawer);}

  /* ---------- PDP ---------- */
  function bindPDP(){
    var main=$('#pdpMain');
    if(main){
      $$('.thumb').forEach(function(t){
        t.addEventListener('click',function(){
          $$('.thumb').forEach(function(x){x.classList.remove('active');});
          t.classList.add('active');
          var src=t.getAttribute('data-img');if(src)main.querySelector('img').src=src;
        });
      });
    }
    /* size/variant select */
    $$('[data-variant-group]').forEach(function(group){
      $$('.vopt',group).forEach(function(opt){
        opt.addEventListener('click',function(){
          $$('.vopt',group).forEach(function(x){x.classList.remove('active');});
          opt.classList.add('active');updateVariant();
        });
      });
    });
    /* qty */
    var qi=$('#pdpQty');
    var dec=$('#qtyDec'),inc=$('#qtyInc');
    if(dec)dec.addEventListener('click',function(){qi.value=Math.max(1,parseInt(qi.value,10)-1);});
    if(inc)inc.addEventListener('click',function(){qi.value=parseInt(qi.value,10)+1;});
    /* accordions */
    $$('.acc>button').forEach(function(b){b.addEventListener('click',function(){b.parentElement.classList.toggle('open');});});
    updateVariant();
  }
  function updateVariant(){
    var data=window.__thshVariants;if(!data)return;
    var chosen={};
    $$('[data-variant-group]').forEach(function(g){var a=$('.vopt.active',g);if(a)chosen[g.getAttribute('data-variant-group')]=a.getAttribute('data-value');});
    var match=null;
    data.forEach(function(v){
      var ok=true;
      for(var i=0;i<v.options.length;i++){var name=window.__thshOptionNames[i];if(chosen[name]&&chosen[name]!==v.options[i])ok=false;}
      if(ok&&!match)match=v;
    });
    var idInput=$('#pdpVariantId'),btn=$('#pdpAdd'),price=$('#pdpPrice');
    if(match){
      if(idInput)idInput.value=match.id;
      if(btn){btn.disabled=!match.available;btn.textContent=match.available?('Add to cart · '+money(match.price)):'Sold out';}
      if(price)price.firstChild&&(price.firstChild.textContent=money(match.price));
    }
  }

  /* ---------- collection filter + sort (client helper; Shopify URL drives real data) ---------- */
  function bindCollectionTools(){
    var pills=$$('.pill[data-filter]');
    if(pills.length){
      pills.forEach(function(p){
        p.addEventListener('click',function(){
          pills.forEach(function(x){x.classList.remove('active');});p.classList.add('active');
          var f=p.getAttribute('data-filter');
          var shown=0;
          $$('[data-product]').forEach(function(card){
            var tags=(card.getAttribute('data-tags')||'').toLowerCase();
            var type=(card.getAttribute('data-type')||'').toLowerCase();
            var ok=(f==='all')||tags.indexOf(f)>-1||type.indexOf(f)>-1;
            card.style.display=ok?'':'none';if(ok)shown++;
          });
          var c=$('#prodCount');if(c)c.textContent=shown+(shown===1?' product':' products');
        });
      });
    }
    var sort=$('#sortSelect');
    if(sort)sort.addEventListener('change',function(){
      var v=sort.value;var url=new URL(location.href);url.searchParams.set('sort_by',v);location.href=url.toString();
    });
  }

  /* ---------- reveal on scroll ---------- */
  function bindReveal(){
    var els=$$('.reveal');if(!els.length)return;
    if(!('IntersectionObserver'in window)){els.forEach(function(e){e.classList.add('in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{threshold:.12});
    els.forEach(function(e){io.observe(e);});
  }

  document.addEventListener('DOMContentLoaded',function(){
    bindMobileMenu();bindSearch();bindCartTriggers();bindAddToCart();
    bindPDP();bindCollectionTools();bindReveal();
    fetchCart(function(cart){renderDrawer(cart);});
  });
})();
